import { FlagIcon } from "@heroicons/react/24/solid";
import React from "react";

type Props = {
  list: string[];
};

export const FlagsList = ({ list }: Props) => {
  return (
    <div className="flex gap-3 p-2 flex-wrap my-2">
      {list.map((text, idx) => (
        <div className="flex gap-2" key={idx}>
          <FlagIcon className="w-4 text-green-600" />
          <span>{text}</span>
        </div>
      ))}
    </div>
  );
};
